module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/hero-600-c2e77b674593012eafecfc226232521b.jpg";